<template>
  <div class="content" style="margin-top: -35px">
    <div class="table-wrap">
      <table>
        <colgroup>
          <col style="width: 1265px" />
          <col style="width: 430px" />
        </colgroup>
        <tr>
          <td>
            <p class="lead">
              操作履歴を表示します。業務や対象者ごとの操作履歴を確認できます。
            </p>
            <p class="sup-explanation">履歴の保持期間は１年です。</p>
          </td>
          <td>
            <button
              class="frm-btn ico ico-export"
              type="button"
              style="width: 150px"
              @click="handleExport"
              ref="exportButton"
            >
              エクスポート
            </button>
            <span style="margin-left: 10px; font-size: 25px">|</span>
            <button
              class="frm-btn ico ico-delete"
              type="button"
              @click="handleDelete"
            >
              操作履歴を削除
            </button>
          </td>
        </tr>
      </table>
    </div>
    <!-- ******************************************************************
            *  フィルタ条件                                                  *
          ******************************************************************-->
    <div class="criteria">
      <!-- ******************************************************************
                   *  一覧検索                                                      *
                   ****************************************************************** -->
      <div class="frm-row">
        <div class="frm-item">
          <div
            class="frm-search frm-size-xl"
            :class="searchKey ? 'setvalue' : ''"
          >
            <span class="frm-label" style="margin-left: 0.5em">
              <img src="@/assets/images/TDSDC/icon_search.png" />
            </span>
            <input
              type="search"
              ref="searchIndex"
              class="frm-search-text"
              placeholder="検索キーワード"
              maxlength="255"
              @change="setFilter"
              v-model.trim="searchKey"
              tabindex="0"
            />
          </div>
        </div>
        <div class="frm-item">
          <span class="frm-label">処理日時</span>
          <select
            class="frm-select frm-size-s"
            :class="displayTarget ? 'setvalue' : ''"
            :disabled="displayTarget == '99'"
            v-model="displayTarget"
          >
            <option
              v-for="(month, index) in dateTimeList"
              :key="index"
              :value="month[1] + '-' + month[2]"
              :class="
                displayTarget == month[1] + '-' + month[2]
                  ? 'setvalue'
                  : 'not-setvalue'
              "
            >
              {{ month[0] }}
            </option>
            <option value="99" hidden disabled>詳細指定中</option>
          </select>
          <span class="frm-label">アカウント種別</span>
          <select class="frm-select frm-size-m setvalue" v-model="accountType">
            <option
              value="0"
              :class="accountType == '0' ? 'setvalue' : 'not-setvalue'"
            >
              税理士事務所
            </option>
            <option
              value="2"
              :class="accountType == '2' ? 'setvalue' : 'not-setvalue'"
            >
              事業者
            </option>
          </select>
        </div>
        <!--絞込条件設定-->
        <div class="frm-item">
          <button
            class="frm-btn"
            :class="[motoPageHandleShowBtn ? showUsed : showUnused]"
            @click="handleShowFilter"
          ></button>
        </div>
        <!--すべてクリアボタン-->
        <div class="frm-item" style="margin-left: 10px">
          <button
            class="frm-btn-control ico ico-filter-close"
            :disabled="isResetDisabled"
            @click="handleReset"
          ></button>
        </div>
      </div>
    </div>

    <div class="frm-row">
      <div v-show="showCount" class="frm-item grow right">
        <p>{{ this.filteredTableList.length.toLocaleString() }}/{{ this.allData.length.toLocaleString() }}件</p>
      </div>
    </div>
    <!-- ******************************************************************
               *  アクセスログ一覧                                              *
          ******************************************************************-->
    <div class="table-wrap" style="margin-top: 0px">
      <div class="table-scroll-header">
        <table class="table-select single-select">
          <colgroup>
            <!--チェックボックス-->
            <col style="width: 40px" />
            <!--処理日時-->
            <col style="width: 95px" />
            <!--処理対象-->
            <col style="width: 120px" />
            <!--処理データ-->
            <col style="width: auto" />
            <!--処理区分-->
            <col style="width: 80px" />
            <!--ログインID-->
            <col style="width: 150px" />
            <!--利用者名-->
            <col style="width: 150px" />
            <!--IPアドレス-->
            <col style="width: 130px" />
          </colgroup>
          <thead>
            <tr>
              <th class="multi-select-item aligncenter">
                <label class="frm-checkbox">
                  <input
                    type="checkbox"
                    :checked="isAllSelected"
                    :disabled="filteredTableList.length === 0"
                    @change="selectAllRow"
                  />
                  <span
                    class="checkbox-item"
                    tabindex="0"
                    @keydown.space.stop.prevent="selectAllRow"
                  ></span>
                </label>
              </th>
              <th class="sort hover" @click="sortData('accessDateTime')">
                処理日時
                <div class="sort-toggle">
                  <button
                    class="sort-toggle-asc"
                    :class="
                      sort.key == 'accessDateTime' && sort.isAsc ? 'on' : ''
                    "
                    type="button"
                  >
                    asc
                  </button>
                  <button
                    class="sort-toggle-desc"
                    :class="
                      sort.key == 'accessDateTime' && !sort.isAsc ? 'on' : ''
                    "
                    type="button"
                  >
                    desc
                  </button>
                </div>
              </th>
              <th class="sort hover alignleft" @click="sortData('objectType')">
                処理対象
                <div class="sort-toggle">
                  <button
                    class="sort-toggle-asc"
                    :class="sort.key == 'objectType' && sort.isAsc ? 'on' : ''"
                    type="button"
                  >
                    asc
                  </button>
                  <button
                    class="sort-toggle-desc"
                    :class="sort.key == 'objectType' && !sort.isAsc ? 'on' : ''"
                    type="button"
                  >
                    desc
                  </button>
                </div>
              </th>
              <th class="sort hover alignleft" @click="sortData('objectName')">
                処理データ
                <div class="sort-toggle">
                  <button
                    class="sort-toggle-asc"
                    :class="sort.key == 'objectName' && sort.isAsc ? 'on' : ''"
                    type="button"
                  >
                    asc
                  </button>
                  <button
                    class="sort-toggle-desc"
                    :class="sort.key == 'objectName' && !sort.isAsc ? 'on' : ''"
                    type="button"
                  >
                    desc
                  </button>
                </div>
              </th>
              <th class="sort hover" @click="sortData('operation')">
                処理
                <br />区分
                <div class="sort-toggle">
                  <button
                    class="sort-toggle-asc"
                    :class="sort.key == 'operation' && sort.isAsc ? 'on' : ''"
                    type="button"
                  >
                    asc
                  </button>
                  <button
                    class="sort-toggle-desc"
                    :class="sort.key == 'operation' && !sort.isAsc ? 'on' : ''"
                    type="button"
                  >
                    desc
                  </button>
                </div>
              </th>
              <th class="sort hover alignleft" @click="sortData('userId')">
                ログインID
                <div class="sort-toggle">
                  <button
                    class="sort-toggle-asc"
                    :class="sort.key == 'userId' && sort.isAsc ? 'on' : ''"
                    type="button"
                  >
                    asc
                  </button>
                  <button
                    class="sort-toggle-desc"
                    :class="sort.key == 'userId' && !sort.isAsc ? 'on' : ''"
                    type="button"
                  >
                    desc
                  </button>
                </div>
              </th>
              <th class="sort hover alignleft" @click="sortData('userName')">
                利用者名
                <div class="sort-toggle">
                  <button
                    class="sort-toggle-asc"
                    :class="sort.key == 'userName' && sort.isAsc ? 'on' : ''"
                    type="button"
                  >
                    asc
                  </button>
                  <button
                    class="sort-toggle-desc"
                    :class="sort.key == 'userName' && !sort.isAsc ? 'on' : ''"
                    type="button"
                  >
                    desc
                  </button>
                </div>
              </th>
              <th class="sort hover" @click="sortData('ipAddress')">
                IPアドレス
                <div class="sort-toggle">
                  <button
                    class="sort-toggle-asc"
                    :class="sort.key == 'ipAddress' && sort.isAsc ? 'on' : ''"
                    type="button"
                  >
                    asc
                  </button>
                  <button
                    class="sort-toggle-desc"
                    :class="sort.key == 'ipAddress' && !sort.isAsc ? 'on' : ''"
                    type="button"
                  >
                    desc
                  </button>
                </div>
              </th>
            </tr>
          </thead>
        </table>
      </div>
      <div class="table-scroll-body h-500px">
        <table class="table-select multi-select">
          <colgroup>
            <!--チェックボックス-->
            <col style="width: 40px" />
            <!--処理日時-->
            <col style="width: 95px" />
            <!--処理対象-->
            <col style="width: 120px" />
            <!--処理データ-->
            <col style="width: auto" />
            <!--処理区分-->
            <col style="width: 80px" />
            <!--ログインID-->
            <col style="width: 150px" />
            <!--利用者名-->
            <col style="width: 150px" />
            <!--IPアドレス-->
            <col style="width: 130px" />
          </colgroup>
          <tbody>
            <tr
              v-for="info in filteredTableList"
              :key="info.logId"
              :class="[info.selected ? 'selected' : '']"
              @click="selectRow(info.logId)"
            >
              <td class="multi-select-item aligncenter">
                <label class="frm-checkbox">
                  <input
                    type="checkbox"
                    :value="info.logId"
                    :checked="info.selected"
                    @change="selectRow(info.logId)"
                  />
                  <span
                    class="checkbox-item"
                    tabindex="0"
                    @keydown.space.stop.prevent="selectRow(info.logId)"
                  ></span>
                </label>
              </td>
              <td class="aligncenter">
                <span>{{ $filters.formatDateTime(info.accessDateTime) }}</span>
              </td>
              <!--処理対象-->
              <td>
                <!-- <span>{{ typeFormat(info.objectType) }}</span> -->
                <span>{{ objectTypeFormat(info.objectType) }}</span>
              </td>
              <!--処理データ-->
              <td>
                <span>{{ info.objectName }}</span>
              </td>
              <!--処理区分-->
              <td class="aligncenter">
                <span>{{ typeFormat(info.operation) }}</span>
              </td>
              <td>
                <span>{{ info.userId }}</span>
              </td>
              <td>
                <span>{{ info.userName }}</span>
              </td>
              <td class="aligncenter">
                <span>{{ info.ipAddress }}</span>
              </td>
            </tr>
          </tbody>
        </table>

        <table
          class="table-select single-select"
          v-show="!isProcessShow && this.filteredTableList.length === 0"
        >
          <tbody>
            <tr>
              <br />
              {{
                noDataMsg
              }}
              <br />
              <br />
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <STDSDC01C04ProcessingCompleteModal></STDSDC01C04ProcessingCompleteModal>
  <STDSDC01C06FileExportModal
    pageId="STDSDC05C09"
    :dateFrom="dateFrom"
    :dateTo="dateTo"
  ></STDSDC01C06FileExportModal>
  <!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
  _/                                                                                                                    _/
  _/      子画面定義：処理確認画面(STDSDC01C07ProcessingConfirmModal)  収集書類情報複写確認                                                   _/
  _/                                                                                                                    _/
  _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/-->
  <STDSDC01C07ProcessingConfirmModal
    :isConfirmShow="isConfirmShow"
    :textArea="textArea"
    :deleteCheck="deleteCheck"
    @agree="agree($event)"
    @disagree="disagree"
  ></STDSDC01C07ProcessingConfirmModal>

  <confirm-dialog
    :isShow="isShow"
    :message="content"
    @confirm="confirm"
    @cancel="cancel"
  ></confirm-dialog>

  <STDSDC01C09FilterCompleteModal
    ref="STDSDC01C09FilterCompleteModal"
    :isShow="isFilterShow"
    pageId="STDSDC05C09"
    :loginSystem="loginSystem"
    :keyWordFilterInit="searchKey"
    :accessLogFilterInit="returnAccessLogFilter"
    :STDSDC05C09FilterInit="{
      displayTarget: displayTargetTransform,
      dateTimeList: dateTimeList,
    }"
    @SearchBtn="SearchBtn"
    @CancelBtn="CancelBtn"
  >
  </STDSDC01C09FilterCompleteModal>
</template>
<script>
import { mapGetters, mapMutations, useStore } from "vuex";
import _ from "lodash";
import Common from "@/util/common.js";
import moment from "moment";
import Validation from "@/util/validation.js";
import STDSDC01C04ProcessingCompleteModal from "@/components/STDSDC01C04ProcessingCompleteModal.vue";
import STDSDC01C06FileExportModal from "@/components/STDSDC01C06FileExportModal.vue";
import STDSDC01C09FilterCompleteModal from "@/components/STDSDC01C09FilterCompleteModal.vue";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import { TREAM_TARGET, TREAM_TARGET_FILEMANAGE } from "@/util/enum.js";
import { FILEMANAGE_OPERATION_STATUS } from "@/util/enum.js";
import STDSDC01C07ProcessingConfirmModal from "@/components/STDSDC01C07ProcessingConfirmModal.vue";
import {
  FISCAL_YEAR_LIST,
  YEAR_LIST,
  BUSINESS_DATA_LIST,
} from "@/util/data.js";
import {
  wareki,
  seireki,
  warekiToYear,
  yearToWareki,
  verifyDate,
  verifyMonth,
  isDate,
} from "@/util/dateFormat.js";
import {
  API_DisplayAccessLog,
  API_DeleteAccessLog,
  API_Research,
} from "@/api/Modules/DC05/STDSDC05C09.js";
import { API_SetFilter } from "@/api/Modules/CM04/STDSCM04C00.js";
import { nextTick } from "vue";

export default {
  name: "STDSDC05C09OperationHistory",
  components: {
    STDSDC01C04ProcessingCompleteModal,
    STDSDC01C06FileExportModal,
    ConfirmDialog,
    STDSDC01C07ProcessingConfirmModal,
    STDSDC01C09FilterCompleteModal,
  },

  data() {
    return {
      expandFlag: true,
      dropDownList: BUSINESS_DATA_LIST,
      processingDateList: FISCAL_YEAR_LIST,
      yearList: YEAR_LIST,
      periodYearStart: "",
      periodMonthStart: "",
      periodDayStart: "",
      periodYearEnd: "",
      periodMonthEnd: "",
      periodDayEnd: "",
      storeYearStart: "",
      storeMonthStart: "",
      storeDayStart: "",
      storeYearEnd: "",
      storeMonthEnd: "",
      storeDayEnd: "",
      accountType: 0,
      dateStartSelected: 0,
      yearStartSelected: 0,
      yearStart: "",
      monthStart: "",
      dayStart: "",
      dateEndSelected: 0,
      yearEndSelected: 0,
      yearEnd: "",
      monthEnd: "",
      dayEnd: "",
      processingDataSelected: 0,
      processingDataText: "",
      treatmentTargetText: "",
      processingDivisionText: "",
      businessIdSelected: 0,
      businessIdText: "",
      userNameSelected: 0,
      userNameText: "",
      ipAddressSelected: 0,
      ipAddressText: "",
      searchKey: "",
      selectedInfo: "",
      checkStatus: false,
      isErrorPeriod: false,
      isErrorYearStart: false,
      isErrorYearEnd: false,
      isErrorProcessingDataText: false,
      isErrorTreatmentTargetText: false,
      isErrorProcessingDivisionText: false,
      isErrorBusinessIdText: false,
      isErroruserNameText: false,
      isErrorIpAddressText: false,
      timeFrom: [],
      timeTo: [],
      allData: [],
      tableList: [],
      errors: [],
      highlights: [],
      dateFrom: "",
      dateTo: "",
      isConfirmShow: false,
      status: "",
      isSearchKeyEnter: false,
      sort: {
        key: "", // ソートキー
        isAsc: true, // 昇順ならtrue,降順ならfalse
      },
      noDataPrompt: false,
      totalCount: 0,
      selectCount: 0,
      noDataMsg: Common.getMessage("MTCL1118", ["操作履歴"]),
      startFlg: false,
      showCount: true,
      showUsed: "frm-btn-control setvalue ico ico-filter",
      showUnused: "frm-btn-control ico ico-filter",
      loginSystem: "",
      isFilterShow: false,
      STDSDC05C09FilterInit: {},
      dateTimeList: [],
      displayTarget: "",
      motoPageHandleShowBtn: false,
      returnAccessLogFilter: {},
      defaultDateTime: "",
      // アクセスログ表示の最大件数
      MaxAccessLogDisplay: Common.getSettingsValue("MaxAccessLogDisplay"),      
    };
  },
  mounted() {
    this.generateDateList();
    this.initFocus();
    this.exportDialogue(false);
    // 収集書類情報一覧を取得する
    // 成功の場合
    this.processDialogue(true);
    //検索キーワード適用
    this.isSearchKeyEnter = true;
    API_DisplayAccessLog()
      .then((response) => {
        this.loginSystem = response.loginSystem;
        //期間
        let from = Array(3);
        let to = Array(3);
        from = response.from.split("/");
        to = response.to.split("/");
        this.periodYearStart = from[0];
        this.periodMonthStart = from[1];
        this.periodDayStart = from[2];
        this.periodYearEnd = to[0];
        this.periodMonthEnd = to[1];
        this.periodDayEnd = to[2];
        //期間バックアップ
        this.storeYearStart = this.periodYearStart;
        this.storeMonthStart = this.periodMonthStart;
        this.storeDayStart = this.periodDayStart;
        this.storeYearEnd = this.periodYearEnd;
        this.storeMonthEnd = this.periodMonthEnd;
        this.storeDayEnd = this.periodDayEnd;

        this.dateFrom = response.from;
        this.dateTo = response.to;
        this.dateTimeList.unshift(["直近1か月", this.dateFrom, this.dateTo]);
        this.displayTarget = `${this.dateFrom}-${this.dateTo}`;
        this.defaultDateTime = `${this.dateTimeList[0][1]}-${this.dateTimeList[0][2]}`;
        if (_.eq(response.result, "0000")) {
          this.startFlg = true;

          // 保存されているフィルタ条件の適用
          if (
            response.stdsdC05C09Filter &&
            response.stdsdC05C09Filter.result != "0001"
          ) {
            const {
              timeFromDay,
              timeFromMonth,
              timeFromYear,
              timeToDay,
              timeToMonth,
              timeToYear,
              userType,
              searchKey,
            } = response.stdsdC05C09Filter;

            if (
              this.dateTimeList.some(
                (e) =>
                  `${e[1]}-${e[2]}` ===
                  `${timeFromYear}/${timeFromMonth}/${timeFromDay}-${timeToYear}/${timeToMonth}/${timeToDay}`
              )
            ) {
              this.displayTarget = `${timeFromYear}/${timeFromMonth}/${timeFromDay}-${timeToYear}/${timeToMonth}/${timeToDay}`;
            } else if (
              this.dateTimeList.some(
                (e) => `${e[1]}-${e[2]}` === `${from}-${to}`
              )
            ) {
              this.displayTarget = `${response.from}-${response.to}`;
            } else {
              this.displayTarget = "99";
            }
            this.periodYearStart = timeFromYear;
            this.periodMonthStart = timeFromMonth;
            this.periodDayStart = timeFromDay;
            this.periodYearEnd = timeToYear;
            this.periodMonthEnd = timeToMonth;
            this.periodDayEnd = timeToDay;
            this.accountType = userType;
            this.searchKey = searchKey;
          }
          if (
            response.accessLogFilter.result != "0001" &&
            response.accessLogFilter
          ) {
            this.dateStartSelected =
              response.accessLogFilter.accessDateTimeFromOption;
            this.yearStartSelected =
              response.accessLogFilter.accessDateTimeFromReki;
            this.yearStart = response.accessLogFilter.accessDateTimeFromYear;
            this.monthStart = response.accessLogFilter.accessDateTimeFromMonth;
            this.dayStart = response.accessLogFilter.accessDateTimeFromDay;
            this.dateEndSelected =
              response.accessLogFilter.accessDateTimeToOption;
            this.yearEndSelected =
              response.accessLogFilter.accessDateTimeToReki;
            this.yearEnd = response.accessLogFilter.accessDateTimeToYear;
            this.monthEnd = response.accessLogFilter.accessDateTimeToMonth;
            this.dayEnd = response.accessLogFilter.accessDateTimeToDay;
            this.processingDataSelected =
              response.accessLogFilter.objectNameOption;
            this.processingDataText = response.accessLogFilter.objectName;

            this.treatmentTargetSelected =
              response.accessLogFilter.objectTypeOption;
            this.treatmentTargetText = response.accessLogFilter.objectType;

            this.processingDivisionSelected =
              response.accessLogFilter.operationOption;
            this.processingDivisionText = response.accessLogFilter.operation;

            this.businessIdSelected = response.accessLogFilter.userIDOption;
            this.businessIdText = response.accessLogFilter.userID;
            this.userNameSelected = response.accessLogFilter.userNameOption;
            this.userNameText = response.accessLogFilter.userName;
            this.ipAddressSelected = response.accessLogFilter.ipAddressOption;
            this.ipAddressText = response.accessLogFilter.ipAddress;
            this.returnAccessLogFilter = response.accessLogFilter;
            this.motoPageHandleShowBtn =
              response.accessLogFilter.motoPageHandleShowBtn;
          }
          if (
            response.keywordFilter.result != "0001" &&
            response.keywordFilter
          ) {
            this.searchKey = response.keywordFilter.searchKey;
          }
          if (this.displayTarget == "99") {
            let timeStart =
              this.periodYearStart +
              "/" +
              this.periodMonthStart +
              "/" +
              this.periodDayStart;
            let timeEnd =
              this.periodYearEnd +
              "/" +
              this.periodMonthEnd +
              "/" +
              this.periodDayEnd;
            this.reSearchData(`${timeStart}-${timeEnd}`);
          }
        }
        //上記以外の場合
        else {
          this.errors = [];
          if (response.errorCD) {
            if (response.errorCD == "MTCL1036") {
              this.tableList = [];
              this.allData = [];
            } else {
              // エラー表示
              this.errors.push(
                Common.createError(
                  response.errorCD,
                  Common.getMessage(response.errorCD, [])
                )
              );
            }
          }
        }

        this.processDialogue(false);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        this.initFocus();
      });
  },
  watch: {
    searchKey: {
      handler: "filterContext",
      immediate: true,
    },
    displayTarget: {
      handler: "displayTargetChange",
      immediate: true,
    },
    accountType: {
      handler: "radioChange",
      immediate: true,
    },
    errors: {
      handler: "errorsChange",
      immediate: true,
    },
  },
  computed: {
    ...mapGetters("businessModule", [
      "isProcessShow",
      "isCompleteShow",
      "isExportShow",
      "isDeleteShow",
    ]),
    //リセット制御
    isResetDisabled() {
      if (
        !this.searchKey &&
        this.displayTarget == this.defaultDateTime &&
        this.accountType == 0 &&
        !this.motoPageHandleShowBtn
      ) {
        return true;
      } else {
        return false;
      }
    },
    displayTargetTransform() {
      if (!this.displayTarget) {
        const today = new moment().format("YYYY/MM/DD");
        const todayLastMonth = moment(new Date())
          .add("days", -30)
          .format("YYYY/MM/DD");
        return todayLastMonth + "-" + today;
      }
      if (this.displayTarget == "99") {
        return "99";
      }
      const targetIndex = this.dateTimeList.findIndex((e) => {
        const timeSplit = this.displayTarget.split("-");
        return `${e[1]}-${e[2]}` === `${timeSplit[0]}-${timeSplit[1]}`;
      });
      if (targetIndex === 0) {
        return this.displayTarget;
      } else {
        const target = this.displayTarget.split("-");
        return target[0].replace("/01", "");
      }
    },
    // **********************************************
    // アカウント種別の検索
    // **********************************************
    filteredTableList() {
      let filterInfo = this.allData;
      filterInfo = filterInfo.filter((item) => {
        return item.keyNameType == this.accountType;
      });

      if (this.searchKey) {
        //検索キーワード
        filterInfo = filterInfo.filter((item) => {
          return (
            this.$filters
              .formatDateTime(item.accessDateTime)
              .includes(this.searchKey) ||
            item.objectName.includes(this.searchKey) ||
            this.objectTypeFormat(item.objectType).includes(this.searchKey) ||
            this.typeFormat(item.operation).includes(this.searchKey) ||
            item.userId.includes(this.searchKey) ||
            item.userName.includes(this.searchKey) ||
            item.ipAddress.includes(this.searchKey)
          );
        });
      }

      //ソート実行
      filterInfo = Common.listSort(this.sort.key, this.sort.isAsc, filterInfo);

      //処理対象
      if (this.returnAccessLogFilter.objectType?.length > 0) {
        filterInfo = filterInfo.filter((element) => {
          return this.returnAccessLogFilter.objectType.some(
            (e) => e == element.objectType
          );
        });
      }
      //処理データ
      if (!!this.returnAccessLogFilter.objectName) {
        // 「右記を含む」の場合
        if (this.returnAccessLogFilter.objectNameOption == "1") {
          filterInfo = filterInfo.filter((element) => {
            return _.includes(
              element.objectName.toString(),
              this.returnAccessLogFilter.objectName
            );
          });
          // 「右記を含まない」の場合
        } else if (this.returnAccessLogFilter.objectNameOption == "2") {
          filterInfo = filterInfo.filter((element) => {
            return !_.includes(
              element.objectName.toString(),
              this.returnAccessLogFilter.objectName
            );
          });
        }
      }
      //処理区分
      if (this.returnAccessLogFilter.processingDivisionList?.length > 0) {
        filterInfo = filterInfo.filter((element) => {
          return this.returnAccessLogFilter.processingDivisionList.some(
            (e) => e == element.operation
          );
        });
      }

      //ログインID
      if (!!this.returnAccessLogFilter.userID) {
        // 「右記を含む」の場合
        if (this.returnAccessLogFilter.userIDOption == "1") {
          filterInfo = filterInfo.filter((element) => {
            return _.includes(
              element.userId.toString(),
              this.returnAccessLogFilter.userID
            );
          });
          // 「右記を含まない」の場合
        } else if (this.returnAccessLogFilter.userIDOption == "2") {
          filterInfo = filterInfo.filter((element) => {
            return !_.includes(
              element.userId.toString(),
              this.returnAccessLogFilter.userID
            );
          });
        }
      }

      //利用者名
      if (!!this.returnAccessLogFilter.userName) {
        // 「右記を含む」の場合
        if (this.returnAccessLogFilter.userNameOption == "1") {
          filterInfo = filterInfo.filter((element) => {
            return _.includes(
              element.userName.toString(),
              this.returnAccessLogFilter.userName
            );
          });
          // 「右記を含まない」の場合
        } else if (this.returnAccessLogFilter.userNameOption == "2") {
          filterInfo = filterInfo.filter((element) => {
            return !_.includes(
              element.userName.toString(),
              this.returnAccessLogFilter.userName
            );
          });
        }
      }

      //IPアドレス
      if (!!this.returnAccessLogFilter.ipAddress) {
        // 「右記を含む」の場合
        if (this.returnAccessLogFilter.ipAddressOption == "1") {
          filterInfo = filterInfo.filter((element) => {
            return _.includes(
              element.ipAddress.toString(),
              this.returnAccessLogFilter.ipAddress
            );
          });
          // 「右記を含まない」の場合
        } else if (this.returnAccessLogFilter.ipAddressOption == "2") {
          filterInfo = filterInfo.filter((element) => {
            return !_.includes(
              element.ipAddress.toString(),
              this.returnAccessLogFilter.ipAddress
            );
          });
        }
      }
      return filterInfo;
    },
    isAllSelected() {
      return this.filteredTableList.every((info) => info.selected);
    },
    selectedIDList() {
      return this.filteredTableList
        .filter((info) => info.selected)
        .map((info) => {
          return info.logId;
        });
    },
  },
  methods: {
    ...mapMutations("businessModule", [
      "processDialogue",
      "completeDialogue",
      "exportDialogue",
    ]),
    // フィルタ_DB保存
    saveFilter() {
      // パラメータ設定
      const normalFilter = {
        timeFromYear: this.periodYearStart,
        timeFromMonth: this.periodMonthStart,
        timeFromDay: this.periodDayStart,
        timeToYear: this.periodYearEnd,
        timeToMonth: this.periodMonthEnd,
        timeToDay: this.periodDayEnd,
        userType: this.accountType,
      };

      const keyWordFilter = {
        searchKey: this.searchKey,
        pageID: "STDSDC05C09",
        sessinID: this.$cookies.get("SessionID"),
      };

      let params = {
        STDSDC05C09Filter: normalFilter,
        keyWordFilter: keyWordFilter,
      };

      // フィルター条件保存処理
      API_SetFilter(params);
    },
    // **********************************************
    // 処理確認画面ダイアログでOKが選択された時の処理
    // **********************************************
    agree(val) {
      switch (this.status) {
        case "Delete":
          this.deleteData();
          break;
        default:
          break;
      }

      this.isConfirmShow = false;
    },
    // **********************************************
    // 処理確認画面ダイアログでキャンセルが選択された時の処理
    // **********************************************
    disagree() {
      this.isConfirmShow = false;
    },
    // **********************************************
    // *選択データを削除する
    // **********************************************
    deleteData() {
      const param = { logIds: this.selectedIDList };
      // 処理確認「はい」ボタン 非活性化
      this.isDisabled = true;
      API_DeleteAccessLog(param)
        .then((response) => {
          //正常の場合
          if (_.eq(response.result, "0000")) {
            location.reload();
          }
          //上記以外の場合
          else {
            this.errors = [];
            if (response.errorCD) {
              this.errors.push(
                Common.createError(
                  response.errorCD,
                  Common.getMessage(response.errorCD, [])
                )
              );
            }
          }
          // 処理確認「はい」ボタン 活性化
          this.isDisabled = false;
        })
        .catch((error) => {
          console.log(error);
          // 処理確認「はい」ボタン 活性化
          this.isDisabled = false;
        });
    },
    // **********************************************
    // 検索アイコンをクリック時、該当する部分の色を変える
    // **********************************************
    searchNext() {
      if (this.highlights.length > 0) {
        let targetIndex = this.highlightIndex;
        const maxIndex = this.highlights.length - 1;

        targetIndex++;

        if (targetIndex > maxIndex) {
          targetIndex = 0;
        }

        this.highlightIndex = targetIndex;

        for (let i = 0; i < this.highlights.length; i++) {
          const target = this.highlights[i];

          target.classList.remove("currentHighlight");

          if (i === targetIndex) {
            target.classList.add("currentHighlight");
            const offsetTop = target.offsetTop - 10;
            const scrollTop = Math.max(0, offsetTop); // 数値がマイナスの場合はゼロにする
            window.scrollTo(0, scrollTop);
          }
        }
      }
    },
    // // **********************************************
    // // ハイライト表示
    // // **********************************************
    // highlight(val) {
    //   const search = this.searchKey;
    //   return String(val).replace(
    //     search,
    //     `<span class='highlight'>${search}</span>`
    //   );
    // },
    // **********************************************
    // キーワードが変更になったら全てのハイライト部分を取得するようにする
    // **********************************************
    filterContext(keyword) {
      //this.highlightIndex = -1;
      //this.highlights = document.getElementsByClassName("highlight");
      if (this.isSearchKeyEnter) {
        // フィルター条件の保存
        this.saveFilter();
      }
    },

    reSearchData(value) {
      const time = value.split("-");
      const timeFrom = time[0].split("/");
      const timeTo = time[1].split("/");

      this.periodYearStart = timeFrom[0];
      this.periodMonthStart = timeFrom[1];
      this.periodDayStart = timeFrom[2];
      this.periodYearEnd = timeTo[0];
      this.periodMonthEnd = timeTo[1];
      this.periodDayEnd = timeTo[2];
      this.saveFilter();
      this.handleResearch();
    },

    displayTargetChange(newVal, oldVal) {
      if (newVal != oldVal) {
        if (oldVal !== undefined && newVal != "99") {
          this.reSearchData(newVal);
        }
      }
    },
    radioChange(newVal, oldVal) {
      if (oldVal !== undefined && newVal != oldVal) {
        this.saveFilter();
      }
    },
    errorsChange(val) {
      const topError = val?.length > 0 ? val : [];
      // vuex にコミット
      this.$store.commit("securityModule/updateErrors", topError);
      // vuex にコミット
      // this.$store.commit("securityModule/updateErrors", topError);
    },
    // **********************************************
    // データ対象のフォーマット
    // **********************************************
    objectTypeFormat(data) {
      // 事業者情報
      if (data == TREAM_TARGET.businessOperator.code) {
        return TREAM_TARGET.businessOperator.text;

        // 収集書類情報
      } else if (data == TREAM_TARGET.collectedDocument.code) {
        return TREAM_TARGET.collectedDocument.text;

        // ファイル管理
      } else if (data == TREAM_TARGET.fileManage.code) {
        return TREAM_TARGET.fileManage.text;
      }
    },
    // **********************************************
    // データ区分のフォーマット
    // **********************************************
    typeFormat(data) {
      // 新規作成
      if (data == FILEMANAGE_OPERATION_STATUS.create.code) {
        return FILEMANAGE_OPERATION_STATUS.create.text;

        // 開く
      } else if (data == FILEMANAGE_OPERATION_STATUS.open.code) {
        return FILEMANAGE_OPERATION_STATUS.open.text;

        // 保存
      } else if (data == FILEMANAGE_OPERATION_STATUS.save.code) {
        return FILEMANAGE_OPERATION_STATUS.save.text;

        // 削除
      } else if (data == FILEMANAGE_OPERATION_STATUS.delete.code) {
        return FILEMANAGE_OPERATION_STATUS.delete.text;

        // 移動
      } else if (data == FILEMANAGE_OPERATION_STATUS.move.code) {
        return FILEMANAGE_OPERATION_STATUS.move.text;
      }
    },
    // **********************************************
    // 日付のフォーマット(YYYY/MM/DD)
    // **********************************************
    formatDate(value) {
      if (value) {
        return moment(String(value)).format("YYYY/MM/DD hh:mm:ss");
      }
    },
    // **********************************************
    // 全行選択時の処理
    // **********************************************
    selectAllRow() {
      if (this.isAllSelected) {
        this.tableList.forEach((info) => (info.selected = false));
      } else {
        this.tableList.forEach((info) => (info.selected = true));
      }
    },
    // **********************************************
    // 行選択時の処理
    // **********************************************
    selectRow(logId) {
      let log = this.tableList.find((info) => info.logId === logId);
      log.selected = !log.selected;
    },
    // **********************************************
    // エクスポートボタンをクリックする
    // **********************************************
    handleExport() {
      // ダイアログを開く
      this.errors = [];
      this.exportDialogue(true);
    },
    // **********************************************
    // 削除ボタンをクリックする
    // **********************************************
    handleDelete() {
      this.errors = [];
      if (this.selectedIDList.length == 0) {
        this.errors.push(
          Common.createError(
            "MTCL1032",
            Common.getMessage("MTCL1032", ["操作履歴"])
          )
        );
        return;
      }

      // ダイアログを開く
      this.isConfirmShow = true;
      this.textArea = "選択した操作履歴を削除します。よろしいですか？";
      this.deleteCheck = "操作履歴は完全に削除され、復旧することはできません";
      this.status = "Delete";
    },

    // **********************************************
    // 再検索ボタンをクリックする
    // **********************************************
    handleResearch() {
      this.errors = [];
      this.isErrorPeriod = false;
      //期間入力チェック
      var msg = this.checkFilterDateYMD(
        this.periodYearStart,
        this.periodMonthStart,
        this.periodDayStart,
        this.periodYearEnd,
        this.periodMonthEnd,
        this.periodDayEnd,
        "期間"
      );
      // 入力チェック異常の場合、エラーメッセージ表示
      if (msg != "") {
        this.collectedDocuments = [];
        this.isErrorPeriod = true;
        this.errors.push(msg);
        return;
      }

      let timeStart =
        this.periodYearStart +
        "/" +
        this.periodMonthStart +
        "/" +
        this.periodDayStart;
      let timeEnd =
        this.periodYearEnd +
        "/" +
        this.periodMonthEnd +
        "/" +
        this.periodDayEnd;
      this.dateFrom = timeStart;
      this.dateTo = timeEnd;
      const param = {
        Data: [],
        from: timeStart,
        to: timeEnd,
      };
      // 成功の場合
      this.processDialogue(true);
      API_Research(param)
        .then((response) => {
          if (_.eq(response.result, "0000")) {
            //一覧データ
            this.tableList = response.data.filter((row) => {
              return { ...row, selected: false };
            });
            this.allData = [...this.tableList];
            // フィルター条件の保存
            this.saveFilter();
          }
          //失敗の場合
          else {
            this.tableList = [];
            this.allData = [];
            this.errors = [];
            if (response.errorCD) {
              if (response.errorCD == "MTCL1036") {
                this.tableList = [];
                this.allData = [];
              } else if (response.errorCD == "MTCL1151") {
                this.errors.push(
                  Common.createError(
                    response.errorCD,
                    Common.getMessage(response.errorCD, [
                      Number(this.MaxAccessLogDisplay).toLocaleString(),
                    ])
                  )
                );
              } else {
                // エラー表示
                this.errors.push(
                  Common.createError(
                    response.errorCD,
                    Common.getMessage(response.errorCD, [])
                  )
                );
              }
            }
          }
          this.processDialogue(false);
        })
        .catch((error) => {
          console.log(error);
          this.processDialogue(false);
        })
        .finally(() => {
          this.initFocus();
        });
    },
    // **********************************************
    // すべての条件をクリア
    // **********************************************
    handleReset() {
      this.errors = [];
      this.periodYearStart = this.storeYearStart;
      this.periodMonthStart = this.storeMonthStart;
      this.periodDayStart = this.storeDayStart;
      this.periodYearEnd = this.storeYearEnd;
      this.periodMonthEnd = this.storeMonthEnd;
      this.periodDayEnd = this.storeDayEnd;
      this.isErrorPeriod = false;
      this.isErrorYearStart = false;
      this.isErrorYearEnd = false;
      this.isErrorProcessingDataText = false;
      this.isErrorTreatmentTargetText = false;
      this.isErrorProcessingDivisionText = false;
      this.isErrorBusinessIdText = false;
      this.isErroruserNameText = false;
      this.isErrorIpAddressText = false;
      this.accountType = 0;
      this.dateStartSelected = 0;
      this.yearStartSelected = 0;
      this.yearStart = "";
      this.monthStart = "";
      this.dayStart = "";
      this.dateEndSelected = 0;
      this.yearEndSelected = 0;
      this.yearEnd = "";
      this.monthEnd = "";
      this.dayEnd = "";
      this.processingDataSelected = 0;
      this.processingDataText = "";
      this.treatmentTargetText = "";
      this.processingDivisionText = "";
      this.businessIdSelected = 0;
      this.businessIdText = "";
      this.userNameSelected = 0;
      this.userNameText = "";
      this.ipAddressSelected = 0;
      this.ipAddressText = "";
      this.searchKey = "";

      //画面項目設定_アクセスログ情報エリア
      this.returnAccessLogFilter = {
        AccessDateCondition: 0,
        AccessDateFromGengo: 0,
        AccessDateFromYear: "",
        AccessDateFromMonth: "",
        AccessDateFromDay: "",
        AccessDateToGengo: 0,
        AccessDateToYear: "",
        AccessDateToMonth: "",
        AccessDateToDay: "",
        returnCodeAccessDate: 0,
        isErrorAccessDateFromYear: false,
        isErrorAccessDateFromMonth: false,
        isErrorAccessDateFromDay: false,
        isErrorAccessDateToYear: false,
        isErrorAccessDateToMonth: false,
        isErrorAccessDateToDay: false,
        isErrorAccessDate: false,
        isErrorAccessDateMsg: [], //処理日時
        // ProcessingType: [1, 2, 3, 4, 5, 6, 7], //処理種別
        TreatmentTarget: [2, 3, 99], //処理種別
        ObjectNameCondition: 0,
        ObjectName: "",
        isErrorProcessingData: false,
        isErrorProcessingDataMsg: [], //処理データ
        ProcessingDivision: [1, 2, 3, 4, 5, 99], //処理区分
        LoginIDCondition: 0,
        LoginID: "",
        isErrorLoginInID: false,
        isErrorLoginInIDMsg: [], //ログインID
        UserNameCondition: 0,
        UserName: "",
        isErrorUserName: false,
        isErrorUserNameMsg: [], //利用者名ID
        IPAddressCondition: 0,
        IPAddress: "",
        isErrorIPAddress: false,
        isErrorIPAddressMsg: [], //IPアドレス
      };

      this.displayTarget = `${this.dateTimeList[0][1]}-${this.dateTimeList[0][2]}`;
      this.noDataPrompt = false;
      this.motoPageHandleShowBtn = false;
      this.$refs.STDSDC01C09FilterCompleteModal.handleReset();

      // フィルター条件の保存
      this.saveFilter();
    },
    checkFilterDateYMD(yearS, monthS, dayS, yearE, monthE, dayE, label) {
      var rtnS = Validation.verifyDate(yearS, monthS, dayS);
      if (!rtnS) {
        return Common.createError(
          "MTCL1011",
          Common.getMessage("MTCL1011", [label])
        );
      }
      var rtnE = Validation.verifyDate(yearE, monthE, dayE);
      if (!rtnE) {
        return Common.createError(
          "MTCL1011",
          Common.getMessage("MTCL1011", [label])
        );
      }
      var dateS = new Date(yearS, monthS - 1, dayS);
      var dateE = new Date(yearE, monthE - 1, dayE);
      //1月チェック
      var monthDays = moment(dateE).diff(moment(dateS), "days");
      if (monthDays > 30) {
        return Common.createError(
          "MTCL1077",
          Common.getMessage("MTCL1077", [label])
        );
      }
      //条件値(自)＞(至)チェック
      if (dateS > dateE) {
        return Common.createError(
          "MTCL1046",
          Common.getMessage("MTCL1046", [label])
        );
      }
      return "";
    },

    // **********************************************
    // 処理データテキストクリア
    // **********************************************
    clearProcessingDataText() {
      this.processingDataText = "";
    },

    // **********************************************
    // 処理対象テキストクリア
    // **********************************************
    clearTreatmentTargetText() {
      this.treatmentTargetText = "";
    },
    // **********************************************
    // 処理区分テキストクリア
    // **********************************************
    clearProcessingDivisionText() {
      this.processingDivisionText = "";
    },
    // **********************************************
    // ログインID/事業者IDテキスト
    // **********************************************
    clearBusinessIdText() {
      this.businessIdText = "";
    },
    // **********************************************
    // 利用者名テキストクリア
    // **********************************************
    clearuserNameText() {
      this.userNameText = "";
    },
    // **********************************************
    // IPアドレステキストクリア
    // **********************************************
    clearIpAddressText() {
      this.ipAddressText = "";
    },
    // **********************************************
    // 初期フォーカス設定
    // **********************************************
    initFocus() {
      this.$nextTick(() => {
        this.$refs.searchIndex.focus();
      });
    },
    // **********************************************
    // ソート実施
    // **********************************************
    sortData(key) {
      Common.sortData(key, this);
    },
    generateDateList() {
      let dateTime = [];
      for (let i = 0; i > -12; i--) {
        const vStartDate =
          new moment().add("month", i).format("YYYY/MM") + "/01";
        const vEndM = moment(vStartDate).add("month", 1).add("days", -1);
        const vEndDate = moment(vEndM).format("YYYY/MM/DD");
        const text = vEndM.year() + "年" + (vEndM.month() + 1) + "月";
        dateTime.push([text, vStartDate, vEndDate]);
      }
      this.dateTimeList = dateTime;
    },
    SearchBtn(params) {
      const param = _.cloneDeep(params);
      const {
        accessDateTimeFromDay,
        accessDateTimeFromMonth,
        accessDateTimeFromOption,
        accessDateTimeFromReki,
        accessDateTimeFromYear,
        accessDateTimeToDay,
        accessDateTimeToMonth,
        accessDateTimeToReki,
        accessDateTimeToYear,
      } = param.returnAccessLogFilter;
      if (accessDateTimeFromOption == "2") {
        const year = warekiToYear(
          accessDateTimeFromReki == "0" ? "令和" : "平成",
          accessDateTimeFromYear
        );
        const vStartDate =
          year +
          "/" +
          String(accessDateTimeFromMonth).padStart(2, "0") +
          "/" +
          String(accessDateTimeFromDay).padStart(2, "0");
        this.displayTarget = "99";
        this.reSearchData(`${vStartDate}-${vStartDate}`);
      } else if (accessDateTimeFromOption == "3") {
        const year = warekiToYear(
          accessDateTimeFromReki == "0" ? "令和" : "平成",
          accessDateTimeFromYear
        );
        const vStartDate =
          year + "/" + String(accessDateTimeFromMonth).padStart(2, "0") + "/01";
        const vEndM = moment(vStartDate).add("month", 1).add("days", -1);
        const vEndDate = moment(vEndM).format("YYYY/MM/DD");
        if (
          this.dateTimeList.some(
            (e) => `${e[1]}-${e[2]}` === `${vStartDate}-${vEndDate}`
          )
        ) {
          this.displayTarget = `${vStartDate}-${vEndDate}`;
        } else {
          this.displayTarget = "99";
          this.reSearchData(`${vStartDate}-${vEndDate}`);
        }
      } else if (accessDateTimeFromOption == "1") {
        const startYear = warekiToYear(
          accessDateTimeFromReki == "0" ? "令和" : "平成",
          accessDateTimeFromYear
        );

        const endYear = warekiToYear(
          accessDateTimeToReki == "0" ? "令和" : "平成",
          accessDateTimeToYear
        );

        const vStartDate =
          startYear +
          "/" +
          String(accessDateTimeFromMonth).padStart(2, "0") +
          "/" +
          String(accessDateTimeFromDay).padStart(2, "0");
        const vEndDate =
          endYear +
          "/" +
          String(accessDateTimeToMonth).padStart(2, "0") +
          "/" +
          String(accessDateTimeToDay).padStart(2, "0");
        if (
          this.dateTimeList.some(
            (e) => `${e[1]}-${e[2]}` === `${vStartDate}-${vEndDate}`
          )
        ) {
          this.displayTarget = `${vStartDate}-${vEndDate}`;
        } else {
          this.displayTarget = "99";
          this.reSearchData(`${vStartDate}-${vEndDate}`);
        }
      }

      this.motoPageHandleShowBtn = param.motoPageHandleShowBtn;
      this.returnAccessLogFilter = param.returnAccessLogFilter;
      this.searchKey = param.searchKey;
      this.isFilterShow = false;
    },
    CancelBtn() {
      this.isFilterShow = false;
    },
    handleShowFilter() {
      this.isFilterShow = true;
    },
  },
};
</script>

<style>
/* .not-setvalue {
  background: white !important;
} */
</style>
